var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"menu",attrs:{"unique-opened":true,"default-active":_vm.defaultIndex,"text-color":"#bfcbd9","router":"","active-text-color":"#47A6FF","background-color":"#304156"},on:{"select":_vm.handleSelectMenu}},[_c('Menu',{attrs:{"menuList":_vm.menuList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }